import { carregarDesempenho, IndicadoresDesempenho } from '../../../../../Utils/IndicadoresDesempenho';

export type ResumoDia = IndicadoresDesempenho;
export const temAcesso = (valor: unknown) => valor === 'leitura' || valor === 'edicao';
export const podeVerResumo = (acessos?: Record<string, unknown> | null) => temAcesso(acessos?.desempenho);

export function dataBrasilia(agora = new Date()): string {
  const partes = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(agora);
  const valor = (tipo: string) => partes.find(parte => parte.type === tipo)?.value;
  return `${valor('year')}-${valor('month')}-${valor('day')}`;
}

export async function carregarResumoDia(baseUrl: string, loja: string, token: string, dia: string, signal: AbortSignal): Promise<ResumoDia> {
  const { pedidos, faturamento, ticketMedio } = await carregarDesempenho(baseUrl, loja, token, dia, dia, signal);
  return { pedidos, faturamento, ticketMedio };
}
